<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updatePortal">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Update Portal</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData['name']" autofocus :rules="[vRules.required]" density="compact"
                                          label="Name"/>
                            <v-text-field v-model="formData['url']" :rules="[vRules.required, vRules.url]"
                                          density="compact"
                                          label="Url"/>
                            <v-select v-model="formData['type']" :items="['commercial','personal','harvester']"
                                      :rules="[vRules.required]"
                                      density="compact" label="Type"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    portal: {
        type: Object
    }
});

const formData = reactive({
    valid: false,
    name: props.portal.name ?? null,
    url: props.portal.url ?? null,
    type: props.portal.type ?? null,
});
const emits = defineEmits(['update:modelValue', 'updatePortal']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const updatePortal = () => {
    errors.value = [];
    send('put', `admin/portals/${props.portal.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updatePortal', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
